module.exports = __webpack_public_path__ + "static/media/jt5.1eb590f1.png";